var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtGeneratorCreateProject = function SvgIconArtGeneratorCreateProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_art_generator_create_project_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.55 2.4H2.6c-.994 0-1.8.88-1.8 1.965V5.6m3.6 9.6V12m0-9.6v3.2m7.2 9.6V12m0-3.6v.4m3.6 3.2V8.8h-3.6m3.6 3.2v1.235c0 1.085-.806 1.965-1.8 1.965H2.6c-.994 0-1.8-.88-1.8-1.965V12m14.4 0h-3.6m0 0V8.8M.8 12V8.8m0 3.2h3.6m0 0V8.8m0 0V5.6m0 3.2H.8m0 0V5.6m0 0h3.6m8.23.74.178-.407c.315-.721.891-1.3 1.615-1.62l.552-.244a.38.38 0 0 0 .225-.347.38.38 0 0 0-.225-.347l-.521-.23a3.16 3.16 0 0 1-1.638-1.674l-.184-.44A.365.365 0 0 0 12.289.8a.37.37 0 0 0-.342.231l-.184.44a3.16 3.16 0 0 1-1.637 1.675l-.523.23a.38.38 0 0 0-.223.346.38.38 0 0 0 .223.347l.553.243c.724.321 1.3.9 1.615 1.62l.179.408a.37.37 0 0 0 .68 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_art_generator_create_project_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconArtGeneratorCreateProject;